import type { TrainerAvatarCrop } from '@shared/api/contracts';
import {
  DEFAULT_KEEPER_AVATAR,
  playerCampaignPortraitSrc,
  resolveTrainerAvatarUrl,
} from '../utils/trainerAvatar';
import { useT } from "../i18n/i18nContext";

interface TrainerAvatarProps {
  avatar: TrainerAvatarCrop | null;
  /** Diameter in pixels */
  size?: number;
  className?: string;
}

/**
 * Renders a circular trainer avatar from a species evolution image + crop params.
 * Falls back to the default Keeper portrait if no avatar is set — never a placeholder glyph.
 */
export function TrainerAvatar({ avatar, size = 82, className = '' }: TrainerAvatarProps) {
  const t = useT();
  const imageUrl = playerCampaignPortraitSrc(avatar);
  const shown = avatar && resolveTrainerAvatarUrl(avatar) ? avatar : DEFAULT_KEEPER_AVATAR;

  const scale = shown.zoom;
  // Convert normalized crop position to percentage offset from center
  const offsetX = (0.5 - shown.cropX) * 100;
  const offsetY = (0.5 - shown.cropY) * 100;

  return (
    <div
      className={`trainer-avatar-image ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={imageUrl}
        alt={t('progression.trainer.avatarAlt')}
        draggable={false}
        style={{
          transform: `translate(${offsetX}%, ${offsetY}%) scale(${scale})`,
        }}
      />
    </div>
  );
}
